import { getWeb3 } from "./currentWalletHelper"
import { getAddress } from "./addressHelper";
import contracts from "../Config/contracts";
import { getCrowdsaleContract, getEquivalentToken, getTokenContract } from './getterFunctions'
import BigNumber from 'bignumber.js';
import { usdtAbi, crowdSaleAbi, busdAbi } from "../blockchain/abi";
import Web3 from "web3";

export const buyToken = async (tokenAmount, referrer, tokenName, account) => {
    let web3 = await getWeb3()
    let contract = await getCrowdsaleContract();
    let value = 0;
    // console.log("token type is --------->", contracts[tokenName].type);

    // big Number
    if (contracts[tokenName].type == 2) {
        value = await getEquivalentToken(tokenAmount, tokenName);
    }
    value = new BigNumber(value).multipliedBy(new BigNumber(10).exponentiatedBy(new BigNumber(18)));
    console.log("value--------->", referrer, tokenAmount, contracts[tokenName].type)
    tokenAmount = await web3.utils.toWei(tokenAmount.toString())
    let res = await contract.methods.buyTokens(referrer, tokenAmount, contracts[tokenName].type).send({ from: account, value: value })
    console.log("token buy--------->", res)
    return res;
}

export const approveTokens = async (tokenName, account) => {
    let token = await getTokenContract(tokenName);
    let crowdsaleAddress = await getAddress(contracts.crowdsale);
    let tokenAmount = "10000000000000000000000000000000000000000";
    let res = await token.methods.approve(crowdsaleAddress, tokenAmount).send({ from: account })
    return res;
}

export const approveUSDT = async (account, amount, web3) => {
  try {
    if (account) {
      const allawance = await allowanceUSDT(account, web3); 
      if (allawance / 10 ** 18 >= Number(amount) && Number(amount) > 0) {
          return { status: true };
      } else {  
          const CROWD_SALE_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS;
          const USDT_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS_USDT;
          // const web3 = await getWeb3();
          const usdt = await new web3.eth.Contract(usdtAbi, USDT_ADDRESS);
          amount = await web3.utils.toWei(amount.toString());
          let res = await usdt.methods
            .approve(CROWD_SALE_ADDRESS, amount)
            .send({ from: account, value: 0 });
          return res;
      }
    }
  } catch (err) {
    console.log(err);
  }
};

export const buyRobUsingUSDT = async (account, amount, referrer = "", web3) => {
  try {
    if (account) {
      const CROWD_SALE_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS;
      // const web3 = await getWeb3();
      const crowdSale = await new web3.eth.Contract(
        crowdSaleAbi,
        CROWD_SALE_ADDRESS
      );
      amount = await web3.utils.toWei(amount.toString());
      let res = await crowdSale.methods
        .buyUsingUSDT(amount, referrer)
        .send({ from: account, value: 0 });
      return res;
    }
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const approveBUSD = async (account, amount, web3) => {
  try {
    if (account) {
     const allawance = await allowanceBUSD(account, web3); 
     if (allawance / 10 ** 18 >= Number(amount) && Number(amount) > 0) {
         return { status: true };
     } else {
         const CROWD_SALE_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS;
         const BUSD_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS_BUSD;
         // const web3 = await getWeb3();
         const BUSD = new web3.eth.Contract(busdAbi, BUSD_ADDRESS);
         let amt = Web3.utils.toWei(amount.toString());
         const res = await BUSD.methods
              .approve(CROWD_SALE_ADDRESS, amt)
              .send({ from: account })
         return res;     
     }  
    }
  } catch (err) {
    console.log(err);
  }
};

export const buyRobUsingBUSD = async (account, amount, referrer = "", web3) => {
  try {
    if (account) {
      const CROWD_SALE_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS;
      // const web3 = await getWeb3();
      
      const crowdSale = await new web3.eth.Contract(
        crowdSaleAbi,
        CROWD_SALE_ADDRESS
      );
      amount = await web3.utils.toWei(amount.toString());
      const res = await crowdSale.methods
          .buyUsingBUSD(amount, referrer)
          .send({ from: account })
      return res;    
    }
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getPriceWithCode = async (code, web3) => {
  try {
    const CROWD_SALE_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS;
      // const web3 = await getWeb3();
      const crowdSale = await new web3.eth.Contract(
        crowdSaleAbi,
        CROWD_SALE_ADDRESS
      );
      const res = await crowdSale.methods
          .getPriceWithCode(code).call()
      const price = res/100;    
      return price; 
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getUserPromoCode = async (code, web3) => {
  try {
    const CROWD_SALE_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS;
      // const web3 = await getWeb3();
      
      const crowdSale = await new web3.eth.Contract(
        crowdSaleAbi,
        CROWD_SALE_ADDRESS
      );
      const res = await crowdSale.methods
          .address_to_coupons(code).call()   
      return res; 
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const allowanceUSDT = async (account, web3) => {
  try {
    const CROWD_SALE_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS;
    const USDT_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS_USDT;
    // const web3 = await getWeb3();
    const usdt = await new web3.eth.Contract(usdtAbi, USDT_ADDRESS);
    const res = await usdt.methods
      .allowance(
        account,
        CROWD_SALE_ADDRESS
      )
      .call();
    return res; 
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const allowanceBUSD = async (account, web3) => {
  try {
    const CROWD_SALE_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS;
    const BUSD_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS_BUSD;
    // const web3 = await getWeb3();
    const BUSD = await new web3.eth.Contract(busdAbi, BUSD_ADDRESS);
    const res = await BUSD.methods
      .allowance(
        account,
        CROWD_SALE_ADDRESS
      )
      .call();
    return res; 
  } catch (err) {
    console.log(err);
    return err;
  }
};
